import { React, useRef, useState, useEffect } from "react";
import styled, { keyframes }  from "styled-components";
import { useHistory } from 'react-router-dom';

import DayCountInput from '../../../../../Component/MemberComponent/MemberDetail/DayCountInput.js';
import MemberShipSearchInput from '../../../../../Component/MemberComponent/MemberDetail/MemberSearchInput.js';

import FetchModule from '../../../../Share/Network/FetchModule.js';
import DayReasonInput from '../../../../../Component/MemberComponent/MemberDetail/DayReasonInput.js';
import CountInput from '../../../../../Component/MemberComponent/MemberDetail/CountInput.js';
import moment from "moment";
import { useLanguage } from '../../../../../Context/LanguageContext';
import { useTheme } from '../../../../../Context/ThemeContext';

export default function MemberShipExtendModifyModal(props) {
  const { data, onClickExit } = props;

  const history = useHistory();
  const { t } = useLanguage();
  const { isDark } = useTheme();

  const [reason, setReason] = useState('');
  const [extendsDays, setExtendsDays] = useState(0);
  const [extendsCount, setExtendsCount] = useState(0);

  // Scroll Fixed //
  useEffect(() => {
    document.body.style= `overflow: hidden`;
    return () => document.body.style = `overflow: auto`
  }, [])

  // Default Data Setting //
  useEffect(() => {
    setExtendsDays(moment(data.endDate).diff(moment(data.startDate), 'days') + 1);
    setExtendsCount(data.plusTotalMax);
    setReason(data.reason);
  }, [data])

  // 저장하기 버튼 클릭시 //
  function onClickSave() {
    var requestData = {
      extendId: data.extendId,
      usageId: data.usageId,
      reason: reason,
      days: extendsDays,
      plusTotalMax: extendsCount
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('membership/extends/modify', 'POST', requestData);

        if (responseData.status === 200) {
          alert(t('memberDetail.extensionModal.alertExtendModified'));
          onClickExit();
        }
        else if (responseData.status === 204) {
          alert(t('memberDetail.alertMembershipInfoNotFound'));
        }
        else if (responseData.status === 401) {
          alert(t('memberDetail.alertLoginRetry'));
          history.push('/');
        }
      }
    )();
  }

  return (
    <TopLevelWrapper>
      <ModalView $isDark={isDark}>
        <InnerWrapper>
          <TitleWrapper>
            <Title>{t('memberDetail.extensionModal.extendModifyTitle')}</Title>
            <SubTitleWrapper>
              <SubTitle>{data.memberShipName}</SubTitle>
            </SubTitleWrapper>
          </TitleWrapper>
          <ViewWrapper>
            <DateCountWrapper>
              <DayCountInput value={extendsDays} setValue={setExtendsDays} />
              <CountInput value={extendsCount} setValue={setExtendsCount} />
              <DayReasonInput value={reason} setValue={setReason} />
            </DateCountWrapper>
          </ViewWrapper>
          <ButtonWrapper>
            <ExitButton onClick={onClickExit}>{t('memberDetail.modalCancel')}</ExitButton>
            <SaveButton onClick={onClickSave}>{t('memberDetail.modalSave')}</SaveButton>
          </ButtonWrapper>
        </InnerWrapper>
      </ModalView>
    </TopLevelWrapper>
  )
}

const startAnimation = keyframes`
	0% { opacity: 0; }
	50% { opacity: 0.5; }
	100% { opacity: 1; }
`;

const TopLevelWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;

  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  justify-content: center;
  align-items: center;

  z-index: 1000;

  width: 100vw;
  height: 100vh;

  background-color: rgba(0, 0, 0, 0.2);
	
	animation-name: ${startAnimation};
	animation-duration: 0.5s;
	animation-timing-function: ease-out;
`;

const ModalView = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 300px;
  // height: 354px;
  height: 379px;

  border-radius: 30px;
  box-shadow: ${props => props.$isDark ? 'none' : '0px 40px 50px rgba(0, 0, 0, 0.1)'};

  background-color: ${props => props.theme.subBackground};
`;

const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 79.33%;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-end;

  gap: 8px;

  margin-bottom: 27px;
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;

const SubTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  max-width: 152px;
  width: 152px;
  height: 20px;

  overflow: hidden;
`;

const SubTitle = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 12px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;
`;

const ViewWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 36px;
`;

const DateCountWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  // gap: 30px;
  gap: 23px;

  // margin: 0 0 0 28px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  width: 100%;

  gap: 16px;

  margin-top: 24px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 72px;
  height: 38px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 15px;
  background-color: ${props => props.theme.buttonFill};

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.subText};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
      border: 1px solid ${props => props.theme.subText};
      color: ${props => props.theme.subText};
    }
  }
`;

const SaveButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 40px;

  border-radius: 15px;
  background-color: ${props => props.theme.subKey};

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;